<template>
<body>
  <form class="modalContainer active loginModal formsModal">
    <div class="actualModal">
      <router-link to="/login" class="closeModal"><i class="fal fa-times"></i></router-link>
      <div class="modalBodyOfItem">
        <form @submit.prevent="handleSubmit" class="itemBodyLeftModal">
          <h4>Forgot Password</h4>
          <div class="inputsContainer">
            <div class="individualInput">
              <h5>Email Address</h5>
              <input v-model="email" type="text" id="email" placeholder="e.g. your@email.com" />
            </div>
            <!-- <div class="individualInput">
                                <h5>Password</h5>
                                <input v-model="password" type="password" id="password"
                                    placeholder="*******************" />
                            </div> -->
          </div>
          <div class="mobileFlex"></div>
          <div class="quickCheckout">
            <div style="margin-bottom: 5px;" v-if="haserrors" class="error">Please enter a valid email.
            </div>
              <button type="submit">{{buttonText}}</button>
            </div>
            <div class="formBtm">
              <router-link to="/signup" class="signUpBtn">Don't have an account? Sign up</router-link>
            </div>
        </form>
      </div>
    </div>
  </form>
</body>
</template>

<script>
import { userService } from '@/services/user'
import validator from 'validator'
export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      haserrors: false,
      buttonText: 'Send Link'
    }
  },
  methods: {
    handleSubmit(e) {
      let { email } = this
      if (!email || !validator.isEmail(email)) return this.haserrors = true
      userService.forgotPassword(email)
      .then((resp) => {
        if(resp.success) {
          this.buttonText = 'Check Email.'
        } else {
          this.haserrors = true
        }
      })
      .catch(e => {
        console.error(e)
        this.haserrors = true
      })


    }
  }

}
</script>
